// extracted by mini-css-extract-plugin
module.exports = {"staticPage":"staticpages_staticPage__3u4Aa"};